<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'订单维护'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="el-table el-table--fit el-table--striped el-table--scrollable-x el-table--enable-row-transition">
                    <table style="width:100%">
                        <tr>
                            <td>描述</td>
                            <td>操作</td>
                            <td>结果</td>
                        </tr>
                        <tr>
                            <td>获取用户信息</td>
                            <td style="width: 30%">
                                获取用户信息
                                <el-input v-model="getUserinfo" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="getUserinfoClick()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ getUserinfoResult }}
                            </td>
                        </tr>
                        <tr>
                            <td style="color: red;">直接作废sap订单，（不作废本系统的费用，跟预测，特价等，只作废sap）</td>
                            <td style="width: 30%">
                                sap订单号
                                <el-input v-model="zuofeiSapid" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="zuofeiSapBtn()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ zuofeiSapBtnresult }}
                            </td>
                        </tr>
                        <tr>
                            <td style="color: red;">直接作废sap采购订单</td>
                            <td style="width: 30%">
                                采购订单号
                                <el-input v-model="ordercgcode" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="ordercgcodeBtn()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ zuofeicgddhSapBtnresult }}
                            </td>
                        </tr>
                        <tr>
                            <td>从sap查询并更新单个订单</td>
                            <td style="width: 30%">
                                sap订单号
                                <el-input v-model="getSingleOrderStatusSapId" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="getSingleOrderStatus(getSingleOrderStatusSapId)">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ getSingleOrderStatusResult }}
                            </td>
                        </tr>

                        <tr>
                            <td>手动传订单到sap</td>
                            <td style="width: 30%">
                                主订单号
                                <el-input v-model="orderParam2.orderId" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                行项目号
                                <el-input v-model="orderParam2.id" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                sap订单号
                                <el-input v-model="orderParam2.sapCode" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="sendToSapByYourself(orderParam2)">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ result }}
                            </td>
                        </tr>

                        <tr>
                            <td>更新是否异地</td>
                            <td style="width: 30%">
                                <el-button size="small" type="success"
                                           @click="getShifouyidi">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ shifouyidiResult }}
                            </td>
                        </tr>

                        <tr>
                            <td>sap信贷查询</td>
                            <td style="width: 30%">
                                经销商编码
                                <el-input v-model="creditParam.kunnr" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                公司代码
                                <el-input v-model="creditParam.kkber" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="getSapCredit()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ creditResult }}
                            </td>
                        </tr>

                        <tr>
                            <td style="color: red;">sap信贷修改</td>
                            <td style="width: 30%">
                                经销商编码
                                <el-input v-model="creditParam2.kunnr" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                公司代码
                                <el-input v-model="creditParam2.kkber" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                信贷总额
                                <el-input v-model="creditParam2.klimk" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                C-修改,N-创建
                                <el-input v-model="creditParam2.flag" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="updateSapCredit()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ creditResult2 }}
                            </td>
                        </tr>
                        <tr>
                            <td>sap库存查询</td>
                            <td style="width: 30%">
                                物料号
                                <el-input v-model="materialCode" placeholder="请输入"
                                          style="width: 50%"></el-input>例：BE码可空<br/>

                                <el-button size="small" type="success"
                                           @click="tongbuSapKucunshuliang()">sap同步库存
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ searchSapKucunshuliangResult }}
                            </td>
                        </tr>
                        <tr>
                            <td>sap发货过账接口</td>
                            <td style="width: 30%">
                                sap发货过账接口：order_main_product表中：add3字段
                                <el-input v-model="fhgzadd3list" placeholder="请输入" type="textarea"
                                          :rows="5" resize="none"
                                          style="width: 98%"></el-input><br/>

                                <el-button size="small" type="success"
                                           @click="clickfhgzadd3list()">执行过账
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ fhgzadd3listresult }}
                            </td>
                        </tr>
                        <tr>
                            <td>自产传物流（如果有oem直发的话，会传sap报账）</td>
                            <td style="width: 30%">
                                销售单sapcode
                                <el-input v-model="sapcodelist" placeholder="请输入" type="textarea"
                                          :rows="5" resize="none"
                                          style="width: 98%"></el-input><br/>

                                <el-button size="small" type="success"
                                           @click="sapcodelistSendclick()">执行过账
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ sapcodelistresult }}
                            </td>
                        </tr>

                        <tr>
                            <td style="">重新计算可录单数量</td>
                            <td style="width: 30%">
                                预测单Id
                                <el-input v-model="ycid" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="countForecast()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ forecastresult }}
                            </td>
                        </tr>
                        <tr>
                            <td>维护不可签收时间</td>
                            <td style="width: 30%">
                                <brselect  placeholder="请选择产地" category="factory" :v="formInline.factory" :showcode="true"
                                          v-model="formInline.factory" @change="getLastEndTime" :collapse-tags="true" clearable></brselect>
                                <el-date-picker
                                        v-model="formInline.startTime"
                                        type="datetime"
                                        placeholder="选择日期时间"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <span class="w-time-to">至</span>
                                <el-date-picker
                                        v-model="formInline.endTime"
                                        type="datetime"
                                        placeholder="选择日期时间"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <el-button size="small" type="success"
                                           @click="saveEndTime()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ getEndTimeResult }}
                            </td>
                        </tr>

                        <tr>
                            <td style="">同步sap内销回款</td>
                            <td style="width: 30%">
                                经销商编码
                                <el-input v-model="sapAccountNx.userCode" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                公司代码
                                <el-input v-model="sapAccountNx.bukrs" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                年份
                                <el-input v-model="sapAccountNx.year" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                <el-button size="small" type="success"
                                           @click="synNxSapAccount()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ sapAccountResult }}
                            </td>
                        </tr>

                        <tr>
                            <td style="">同步sap外销回款</td>
                            <td style="width: 30%">
                                经销商编码
                                <el-input v-model="sapAccountWx.userCode" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                公司代码
                                <el-input v-model="sapAccountWx.bukrs" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                年份
                                <el-input v-model="sapAccountWx.year" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                <el-button size="small" type="success"
                                           @click="synWxSapAccount()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ sapAccountResultWx }}
                            </td>

                        </tr>

                        <tr>
                            <td>sap查询自产成本</td>
                            <td style="width: 30%">
                                物料编码
                                <el-input v-model="sapBomParam.materialid" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                产地
                                <el-input v-model="sapBomParam.factory" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="getSapBom()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ sapCost }}
                            </td>
                        </tr>

                        <tr>
                            <td>更新mdm物料信息</td>
                            <td style="width: 30%">
                                开始时间
                                <el-input v-model="mdmInfo.STARTDATE" placeholder="请输入"
                                          style="width: 50%"></el-input>例：2024-01-01<br/>
                                截止时间
                                <el-input v-model="mdmInfo.ENDDATE" placeholder="请输入"
                                          style="width: 50%"></el-input>例：2024-01-02<br/>
                                表名
                                <el-input v-model="mdmInfo.table" placeholder="请输入"
                                          style="width: 50%"></el-input> 同步mdm物料输入 1


                                <el-button size="small" type="success"
                                           @click="getMdmInfo()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ sapCost }}
                            </td>
                        </tr>

                        <tr>
                            <td>更新网络诊断数据</td>
                            <td style="width: 30%">
                                年份
                                <el-input v-model="ability.yearStr" placeholder="请输入"
                                          style="width: 50%"></el-input>例如 ：2025<br/>
                                季度
                                <el-input v-model="ability.quarterStr" placeholder="请输入"
                                          style="width: 50%"></el-input>例：1<br/>

                                <el-button size="small" type="success"
                                           @click="createUserSalesAbility()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">

                            </td>
                        </tr>

                        <tr>
                            <td>手动同步sap排产信息</td>
                            <td style="width: 30%">
                                开始时间
                                <el-input v-model="plan.beginDate" placeholder="请输入"
                                          style="width: 50%"></el-input>例如 ：2025-01-01<br/>
                                结束时间
                                <el-input v-model="plan.endDate" placeholder="请输入"
                                          style="width: 50%"></el-input>例如 ：2025-01-01<br/>

                                <el-button size="small" type="success"
                                           @click="sdGetPlan()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">

                            </td>
                        </tr>

                        <tr>
                            <td>手动调用发送万链线索</td>
                            <td style="width: 30%">
                                <el-button size="small" type="success"
                                           @click="sendMsg()">发送通知
                                </el-button>
                            </td>
                            <td style="width: 50%">

                            </td>
                        </tr>

                        <tr>
                            <td>恢复下发暂停及超时</td>
                            <td style="width: 30%">
                                任务编码
                                <el-input v-model="jobCode.jobCode" placeholder="请输入"
                                          style="width: 50%"></el-input>例：wl_status
                                <el-button size="small" type="success"
                                           @click="restoreRun()">执行
                                </el-button>

                            </td>
                            <td style="width: 20%">

                            </td>
                        </tr>

                        <tr>
                            <td>查询阿里云接口获取短信发送详情</td>
                            <td style="width: 30%">
                                <el-button size="small" type="success"
                                           @click="querySmsSendDetail()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">

                            </td>
                        </tr>

                        <tr>
                            <td>手动从万链接口获取招标数据</td>
                            <td style="width: 30%">
                                开始时间
                                <el-input v-model="getWlZhaobiao.startTimes" placeholder="请输入"
                                          style="width: 50%"></el-input>例：2026-01-01 18:00:00<br/>
                                截止时间
                                <el-input v-model="getWlZhaobiao.endTimes" placeholder="请输入"
                                          style="width: 50%"></el-input>例：2026-01-01 20:00:00<br/>

                                <el-button size="small" type="success"
                                           @click="getwlzhaobiao()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">

                            </td>
                        </tr>
                        <tr>
                            <td>经销商注册iam</td>
                            <td style="width: 30%">

                                经销商编码：
                                <el-input v-model="agentUser.userCode" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                经销商名称：
                                <el-input v-model="agentUser.userName" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>
                                手机号码：
                                <el-input v-model="agentUser.phone" placeholder="请输入"
                                          style="width: 50%"></el-input> 11位手机号<br/>
                                邮箱：
                                <el-input v-model="agentUser.email" placeholder="请输入"
                                          style="width: 50%"></el-input>

                                <el-button size="small" type="success"
                                           @click="iamRegister()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ iamRegisterResult }}
                            </td>
                        </tr>

                        <tr>
                            <td>手动计算地市安装报表</td>
                            <td style="width: 30%">
                                年
                                <el-input v-model="installResult.year" placeholder="请输入"
                                          style="width: 50%"></el-input>例：2026<br/>
                                年月
                                <el-input v-model="installResult.yearMonth" placeholder="请输入"
                                          style="width: 50%"></el-input>例：yyyy-MM<br/>
                                经销商名称（可不填）
                                <el-input v-model="installResult.customerName" placeholder="请输入"
                                          style="width: 50%"></el-input>例：宁波高科联合生物科技有限公司<br/>

                                <el-button size="small" type="success"
                                           @click="saveInstallResult()">执行
                                </el-button>
                            </td>
                        </tr>

                        <tr>
                            <td>手动创建营销推广报表</td>
                            <td style="width: 30%">
                                年
                                <el-input v-model="marketing.year" placeholder="请输入"
                                          style="width: 50%"></el-input>例：2026<br/>
                                季度
                                <el-input v-model="marketing.quarter" placeholder="请输入"
                                          style="width: 50%"></el-input>例：1<br/>
                                经销商编码（可不填）
                                <el-input v-model="marketing.customerCode" placeholder="请输入"
                                          style="width: 50%"></el-input>例：88888888<br/>

                                <el-button size="small" type="success"
                                           @click="contractInstall()">执行
                                </el-button>
                            </td>
                        </tr>


                        <tr>
                            <td>手动查询汇率</td>
                            <td style="width: 30%">
                                年
                                <el-input v-model="exchange.fromCurrency" placeholder="请输入"
                                          style="width: 50%"></el-input>例：EUR<br/>
                                季度
                                <exchange-input v-model="marketing.toCurrency" placeholder="请输入"
                                          style="width: 50%"></exchange-input>例：CNY<br/>
                                汇率类型
                                <el-input v-model="exchange.rateType" placeholder="请输入"
                                          style="width: 50%"></el-input><br/>

                                <el-button size="small" type="success"
                                           @click="getExchangeFromSap()">执行
                                </el-button>
                            </td>
                        </tr>

                        <tr>
                            <td>同步三大sap定价</td>
                            <td style="width: 30%">
                                产品编码
                                <el-input v-model="sdMaterialid.materialid" placeholder="请输入"
                                          style="width: 50%"></el-input>例：BE12R0000<br/>

                                <el-button size="small" type="success"
                                           @click="getSdPriceFromSap()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ sdmsg }}
                            </td>
                        </tr>

                        <tr>
                            <td style="color: red;">采购订单-发票校验状态更新</td>
                            <td style="width: 30%">
                                采购订单号或sap45码
                                <el-input v-model="invoiceStatusCode" placeholder="请输入"
                                          style="width: 50%"></el-input>
                                <el-button size="small" type="success"
                                           @click="invoiceStatusBtn()">执行
                                </el-button>
                            </td>
                            <td style="width: 50%">
                                {{ invoiceStatusResult }}
                            </td>
                        </tr>

                    </table>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';
    import customerLedgerService from "../../api/loud/credit/customerDetailsService";
    import supervisorDetailsService from "@/api/loud/credit/supervisorDetailsService";
    import marketingReport from "@/api/loud/agent/marketingReport";

    export default {
        data() {
            return {
                keys: null,
                fhgzadd3list:null,
                fhgzadd3listresult:null,
                getUserinfo:null,
                getUserinfoResult:null,
                getEndTimeResult:null,
                ordercgcode:null,
                zuofeicgddhSapBtnresult:null,
                forecastresult:null,
                ycid:'',
                sapcodelist:null,
                sapcodelistresult:null,
                creditResult: '',
                creditResult2: '',
                shifouyidiResult: '',
                getSingleOrderStatusSapId: '',
                zuofeiSapBtnresult:'',
                dingdanhaolist:'',
                materialCode:'',
                searchSapKucunshuliangResult:'',
                invoiceStatusResult:'',
                zuofeiSapid:'',
                formInline: {
                    startTime: '',
                    endTime:'',
                    factory:''
                },
                getSingleOrderStatusResult: {
                    zwbdr: '',     // ZWBDR  网单号
                    bktxt: '',       // BKTXT  金税发票号
                    soStatus: '',   // SO_STATUS  Y:成功 N：未创建  订单创建状态
                    dnStatus: '',   // DN_STATUS  Y:成功 N：未创建  交货单创建状态
                    pgiStatus: '',   // PGI_STATUS Y:成功 N：未创建  发货状态
                    billingStatus: '',   //BILLING_STATUS  Y:成功 N：未创建  发票状态
                    arStatus: '',    //AR_STATUS  Y:成功 N：未创建  清帐状态
                    message: '',   //MESSAGE  消息文本
                    add1: '',   //备注1
                    add2: '',   //备注2
                    add3: '',   //备注3
                    add4: '',   //备注4
                    add5: '',   //备注5
                    queryTime: '',   //查询状态时间
                },
                orderParam2: {
                    orderId: '',
                    id: '',
                    sapCode: '',
                },
                creditParam: {
                    kunnr: '',
                    kkber: '',
                },
                creditParam2: {
                    kunnr: '',
                    kkber: '',
                    klimk: '',
                    flag: ''
                },
                result: '',
                sapAccountNx:{
                  userCode:'',//经销商编码
                  bukrs:'',//公司编码
                  year:'',
                },
                sapAccountWx:{
                    userCode:'',//经销商编码
                    bukrs:'',//公司编码
                    year:'',
                },
                sapBomParam: {
                    materialid: '',
                    factory: '',
                },
                mdmInfo: {
                    STARTDATE: '',
                    ENDDATE: '',
                    table: '1',
                },
                ability:{
                    yearStr:'',
                    quarterStr:''

                },
                orderCg:{
                    code:'',
                },

                plan:{
                    beginDate:'',
                    endDate:''

                },

                agentUser: {
                    userCode: '',
                    userName: '',
                    phone: '',
                    email: '',
                },
                getWlZhaobiao: {
                    startTimes: '',
                    endTimes: '',
                },
                jobCode:{
                    jobCode:null,
                },


                installResult:{
                    year:null,
                    yearMonth:null,
                    customerName:null,
                },

                marketing: {
                    year:null,
                    quarter:null,
                    customerCode:null,
                },
                exchange:{
                    fromCurrency:null,
                    toCurrency:null,
                    rateType:null,

                },

                sdMaterialid:{
                    materialid:'',
                },
                sdmsg:"",

                iamRegisterResult:'',
                sapCost:'',
                sapAccountResult:'',
                sapAccountResultWx:'',
                invoiceStatusCode: null,
            }
        },
        created() {
          // this.getLastEndTime();
        },
        methods: {
            getUserinfoClick(){
                ss.UserAuthService.getUserInfoToken(this.getUserinfo).then(rd => {
                    this.getUserinfoResult = rd;
                    this.$msg.alert("执行成功！")
                })
            },
            getSingleOrderStatus(param) {
                this.$msg.confirm("确定执行？", () => {
                    ss.OrderService.getSingleOrderStatus(param).then(rd => {
                        this.getSingleOrderStatusResult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },
            zuofeiSapBtn(){
                this.$msg.confirm("确定执行？", () => {
                    ss.OrderService.zuofeiSapBtn(this.zuofeiSapid).then(rd => {
                        this.zuofeiSapBtnresult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },
            ordercgcodeBtn(){
                this.$msg.confirm("确定撤回SAP采购单？", () => {
                    ss.OrderService.zuofeiSapCgddhBtn(this.ordercgcode).then(rd => {
                        this.zuofeicgddhSapBtnresult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },
            sendToSapByYourself(param) {
                console.log('我在这儿呀', param);
                this.$msg.confirm("确定执行？", () => {
                    ss.OrderService.sendToSapByYourself(param).then(rd => {
                        this.result = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },

            getShifouyidi() {
                this.$msg.confirm("确定执行？", () => {
                    ss.OrderService.getShifouyidi().then(rd => {
                        this.shifouyidiResult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },

            getSapCredit() {
                this.$msg.confirm("确定执行？", () => {
                    customerLedgerService.getSapCredit(this.creditParam).then(rd => {
                        this.creditResult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },

            updateSapCredit() {
                this.$msg.confirm("确定执行？", () => {
                    customerLedgerService.updateSapCredit(this.creditParam2).then(rd => {
                        this.creditResult2 = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },
            clickfhgzadd3list() {
                this.$msg.confirm("确定执行？", () => {
                    ss.OrderService.clickfhgzadd3list({fhgzlist:this.fhgzadd3list}).then(rd => {
                        this.fhgzadd3listresult = rd;
                    })
                })
            },

            tongbuSapKucunshuliang(){
                ss.OrderService.tongbuSapKucunshuliang(this.materialCode).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },
            sapcodelistSendclick(){
                this.$msg.confirm("确定执行？", () => {
                    ss.OrderService.sapcodelistSendclick({sapcodelist:this.sapcodelist}).then(rd => {
                        this.sapcodelistresult = rd;
                    })
                })
            },
            countForecast(){
                 this.$msg.confirm("确定重新计算预测单可录单数量？", () => {
                    ss.waixiao.countForecast(this.ycid).then(rd => {
                        this.forecastresult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },

            saveEndTime(){
                let data = {}
                data.startTime = this.formInline.startTime;
                data.endTime = this.formInline.endTime;
                data.factory = this.formInline.factory;
                ss.OrderMainService.saveEndTime(data).then(rd =>{
                    this.getEndTimeResult = rd;
                    this.$msg.alert("执行成功！")
                })
            },

            //判断当前日期是否在允许签收的时间范围之内
            getLastEndTime(){
                var data = {}
                data.factory = this.formInline.factory;
                ss.OrderMainService.getLastEndTime(data).then(rd =>{
                    this.formInline.startTime = rd.msg.startDate;
                    this.formInline.endTime = rd.msg.endDate;
                    console.log("查询输出",this.formInline.startTime)
                    console.log("查询输出2",this.formInline.endTime)
                })
            },
            //单个代理商跟新sap内销回款
            synNxSapAccount(){
                this.$msg.confirm("确定拉取sap内销回款信息？", () => {
                    supervisorDetailsService.synNxSapAccount(this.sapAccountNx).then(rd => {
                        this.sapAccountResult = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },
            //单个代理商跟新sap内销回款
            synWxSapAccount(){
                this.$msg.confirm("确定拉取sap外销回款信息？", () => {
                    supervisorDetailsService.synWxSapAccount(this.sapAccountWx).then(rd => {
                        this.sapAccountResultWx = rd;
                        this.$msg.alert("执行成功！")
                    })
                })
            },

            //获取sap成本
            getSapBom(){

                supervisorDetailsService.getSapBom(this.sapBomParam).then(rd => {
                    this.sapCost = rd.obj;
                    this.$msg.alert("执行成功！")
                })

            },

            //同步mdm物料信息
            getMdmInfo(){
                ss.chanpin.getMdmInfo(this.mdmInfo).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },

            createUserSalesAbility(){
                ss.noticeBoard.createUserSalesAbility(this.ability).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },
            cgSucess(){
                ss.noticeBoard.cgSucess(this.orderCg).then(rd => {
                    this.$msg.alert("执行成功！")
                })

            },

            sdGetPlan(){
                ss.waixiao.sdGetPlan(this.plan).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },

            restoreRun(){
                ss.clueOwner.restoreRun(this.jobCode).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },
            sendMsg(){
                ss.clueOwner.sendMsg().then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },


            querySmsSendDetail(){
                ss.clueOwner.querySmsSendDetail().then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },

            getwlzhaobiao(){
                ss.clueOwner.getwlzhaobiao(this.getWlZhaobiao).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },

            iamRegister(){
                ss.UserAuthService.iamRegister(this.agentUser).then(rd => {

                    this.iamRegisterResult = rd;

                    this.$msg.alert("执行成功！")
                })
            },
            saveInstallResult(){
                marketingReport.saveInstallResult(this.installResult).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },
            contractInstall(){
                marketingReport.contractInstall(this.marketing).then(rd => {
                    this.$msg.alert("执行成功！")
                })
            },
            getExchangeFromSap(){
                ss.OrderMainService.getExchangeFromSap(this.exchange).then(rd => {
                    console.log("exchange="+rd)
                    this.$msg.alert(rd)
                })
            },
            invoiceStatusBtn() {
                const params = {
                    orderCgCode: "",
                    sapCode: ""
                };
                // invoiceStatusCode 若以CG开头则传orderCgCode，若以45开头则传sapCode
                if (this.invoiceStatusCode.indexOf("CG") === 0) {
                    params.orderCgCode = this.invoiceStatusCode;
                } else if (this.invoiceStatusCode.indexOf("45") === 0) {
                    params.sapCode = this.invoiceStatusCode;
                }
                ss.OrderMainService.checkInvoiceStatusManual(params).then(rd => {
                    this.invoiceStatusResult = rd;
                    this.$msg.alert("操作成功！")
                })
            },

            //同步三大sap定价
            getSdPriceFromSap(){
                ss.OrderMainService.getSdPriceFromSap(this.sdMaterialid).then(rd => {
                    this.sdmsg = rd;
                    this.$msg.alert("操作成功！")
                })
            },


        }
    }
</script>
<style>
    .ddqlcpicker .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 0;
    }
    .ddqlcpicker .el-range-editor.el-input__inner{
        padding-right: 0.12rem;
    }
</style>

